<div class="modal {active ? 'is-active': ''}">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">{positionName} Depth Chart</p>
            <button class="delete" aria-label="close" on:click='set({active: false})'></button>
        </header>
        <section class="modal-card-body">
            <div class='columns'>
                <div class='column is-half'>
                    <nav class='panel'>
                        <div class='panel-heading has-background-primary has-text-white'>
                            Players
                        </div>
                        <p class='panel-block roster-player {droptarget == 0 ? "has-background-grey-light":""}' on:dragover="dragover(event,0)" on:dragleave="dragleave(event,0)" on:drop="drop(event, 0)">
                            <span class='panel-icon lineup-id'>1</span>
                            {#if chart[0].last}
                                {chart[0].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(0)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player {droptarget == 1 ? "has-background-grey-light":""}' on:dragover="dragover(event,1)" on:dragleave="dragleave(event,1)" on:drop="drop(event, 1)">
                            <span class='panel-icon lineup-id'>2</span>
                            {#if chart[1].last}
                                {chart[1].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(1)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player {droptarget == 2 ? "has-background-grey-light":""}' on:dragover="dragover(event,2)" on:dragleave="dragleave(event,2)" on:drop="drop(event, 2)">
                            <span class='panel-icon lineup-id'>3</span>
                            {#if chart[2].last}
                                {chart[2].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(2)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player {droptarget == 3 ? "has-background-grey-light":""}' on:dragover="dragover(event,3)" on:dragleave="dragleave(event,3)" on:drop="drop(event, 3)">
                            <span class='panel-icon lineup-id'>4</span>
                            {#if chart[3].last}
                                {chart[3].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(3)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player {droptarget == 4 ? "has-background-grey-light":""}' on:dragover="dragover(event,4)" on:dragleave="dragleave(event,4)" on:drop="drop(event, 4)">
                            <span class='panel-icon lineup-id'>5</span>
                            {#if chart[4].last}
                                {chart[4].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(4)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                    </nav>
                </div>
                <div class='column is-half'>
                    <nav class='panel'>
                        <div class='panel-heading has-background-primary has-text-white'>
                            Available Players
                        </div>
                        {#each availablePlayers as player}
                        <p class='panel-block has-background-white' draggable="true" on:dragstart="dragstart(event, player.number)" on:dragend="dragend(event)">
                            <span class='panel-icon lineup-id'>{player.number}</span>
                            {#if player.last}{player.last}, {player.first}{:else}&nbsp;{/if}
                        </p>
                        {/each}
                    </nav>
                </div>
            </div>
        </section>
    </div>
</div>

<script>
    export default {
        data() {
            return {
                active: false,
                posNum: 0,
                chart: [],
                droptarget: -1
            };
        },
        computed: {
            availablePlayers: function ({ chart, $roster }) {
                let available = [];
                for (var playerIdx in $roster) {
                    let player = $roster[playerIdx];
                    let found = false;
                    for (var idx = 0; idx < 5; idx++) {
                        let positionPlayer = chart[idx];
                        if (positionPlayer && positionPlayer.first == player.first && positionPlayer.last == player.last) {
                            found = true;
                        }
                    }
                    if (!found) {
                        available.push(player);
                    }
                }
                return available;
            }
        },
        methods: {
            dragstart(ev, playerNum) {
                ev.dataTransfer.setData("playerNum", playerNum);
            },
            dragend(ev) {

            },
            dragover(ev, position) {
                ev.preventDefault();
                this.set({droptarget: position})
                ev.dataTransfer.dropEffect = 'move';
            },
            dragleave(ev, position) {
                ev.preventDefault();
                const {droptarget} = this.get();
                if(droptarget == position) {
                    this.set({droptarget: -1});
                }
            },
            drop(ev, position) {
                ev.preventDefault();
                var playerNum = ev.dataTransfer.getData("playerNum");
                const {depthChart, roster} = this.store.get();
                let movedPlayer = roster.find(function(player) {
                    return player.number == playerNum;
                });
                if(movedPlayer) {
                    const { chart, posNum } = this.get();
                    chart[position] = movedPlayer;
                    this.set({ chart });
                    depthChart[posNum] = chart;
                    this.store.set({depthChart});
                }
                this.set({droptarget: -1});
            },
            clearPlayer(position) {
                const { chart, posNum } = this.get();
                chart[position] = {};
                this.set({ chart });
                const {depthChart} = this.store.get();
                depthChart[posNum] = chart;
                this.store.set({depthChart});
            }
        }
    }
</script>

<style>
    [draggable] {
        user-select: none;
        -webkit-user-drag: element;
    }
    .fa-lg {
        line-height: 1em;
    }
    .panel-icon {
        vertical-align: inherit;
    }
    .roster-player {
        display: block;
        padding: 0.4em 0.75em;
    }
</style>
